import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import PortalTextBox from '../../portal/portalTextBox';
import { TransparentButton, Button, ButtonType } from '@checkmarx/cx-ui';
import TextfieldFloatingText from '../../portal/textfieldFloatingText';
import classNames from 'classnames';
import ToastrLevelsEnum from '../../../services/enums/toastrLevelsEnum';
import ToastrService from '../../../services/ui/toastrService';

@inject('translationsStore', 'passwordPoliciesStore') @observer
export default class LockoutPolicy extends Component {

    policiesStore = this.props.passwordPoliciesStore;
    lockoutOptions = this.props.passwordPoliciesStore.lockoutOptions;
    t = this.props.translationsStore;

    componentDidMount() {
        this.policiesStore.getLockoutOptions();
    }

    handleLockoutTimeChange = e => this.policiesStore.setLockoutTimespan(e.target.value);
    handleLockoutTimeOnBlur = e => this.policiesStore.validateLockoutTime();

    handleFailedAttemptsChange = e => this.policiesStore.setMaxFailedAttempts(e.target.value);
    handleFailedAttemptsOnBlur = e => this.policiesStore.validateMaxFailedAttempts();

 
    handleSubmitForm = (e) => {
        e.preventDefault();

        const isValid = this.policiesStore.validateLockoutForm();

        if (isValid === false) {
            return;
        }

        this.policiesStore.saveLockoutOptions().then((response) => {
            var level = ToastrLevelsEnum.SUCCESS;
            var message = this.props.translationsStore.translate('LOCKOUT_OPTIONS_SUCCESS_MESSAGE');
            ToastrService.triggerToastr({ level, message });
        });
    }

    fieldWidth = '48%';


    render() {
        return (
            <form onSubmit={this.handleSubmitForm}>
                <div>
                    <div className="setting-sub-title">
                        {this.t.translate('LOCKOUT_OPTIONS_SUB_TITLE')}
                    </div>
                    <div className='ldap-server-settings-form-main-wrapper'>
                        <div className='form-row start'>
                            <PortalTextBox
                                dataCy={'txt-lockout-time'}
                                hintText={this.t.translate('LOCKOUT_TIME')}
                                floatingLabelText={<TextfieldFloatingText title={this.t.translate('LOCKOUT_TIME')}
                                    required={true} />}
                                onChange={this.handleLockoutTimeChange}
                                onBlur={this.handleLockoutTimeOnBlur}
                                width={this.fieldWidth}
                                errorText={this.policiesStore.lockoutTimeValidationMessage}
                                disabled={this.policiesStore.savingPolicy}
                                value={this.lockoutOptions.defaultLockoutTimeSpan}
                            />
                        </div>
                        <div className='form-row start'>
                            <PortalTextBox
                                dataCy={'txt-lockout-max-failed-attempts'}
                                hintText={this.t.translate('LOCKOUT_FAILED_ATTEMPTS')}
                                floatingLabelText={<TextfieldFloatingText title={this.t.translate('LOCKOUT_FAILED_ATTEMPTS')}
                                    required={true} />}
                                onChange={this.handleFailedAttemptsChange}
                                onBlur={this.handleFailedAttemptsOnBlur}
                                width={this.fieldWidth}
                                errorText={this.policiesStore.maxFailedAttemptsValidationMessage}
                                disabled={this.policiesStore.savingPolicy}
                                value={this.lockoutOptions.maxFailedAccessAttempts}
                            />
                        </div>
                    </div>
                    <div className='general-settings-submit'>
                        <Button
                            dataCy='btn-lockout-options-submit'
                            type='submit'
                            inProgress={this.policiesStore.savingPolicy}
                            text={this.props.translationsStore.translate('SAVE')} >
                        </Button>
                    </div>
                </div>
            </form>
        );
    }
}